import { createContext, use } from 'react'

import { CommonAnalyticsServiceType } from '../analytics'

interface CommonAnalyticsContextData {
  analyticsService: CommonAnalyticsServiceType
  shouldSkipPageViewEvents?: boolean
}

export const CommonAnalyticsContext = createContext({} as CommonAnalyticsContextData)

export const useCommonAnalyticsContext = () => {
  return use(CommonAnalyticsContext)
}
